var INPUTRULES = {
  email: /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
  mobile: /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(14[0-9]{1}))+\d{8})$/,
  id: /^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|2010)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/,
  realname: /^[\u4e00-\u9fa5]{2,9}$/,
  enterprise: /^[\u4e00-\u9fa5]{3,51}/,
  zipcode: /^[0-9]{6}$/,
  fixedTel: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
  qrcode: /^[a-zA-Z0-9]{4}$/,
  url: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
  domain: /([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
};

var serverInfo = {
  protocol: window.location.protocol,
  host: window.location.host,
  port: window.location.port,
  path: window.location.pathname,
};

export default {
  INPUTRULES: {
    email: /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, //复杂版
    // email: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    mobile: /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(16[0-9]{1})|(19[0-9]{1})|(14[0-9]{1}))+\d{8})$/,
    id: /^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|2010)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/,
    realname: /^[\u4e00-\u9fa5]{2,9}$/,
    enterprise: /^[\u4e00-\u9fa5]{3,51}/,
    zipcode: /^[0-9]{6}$/,
    fixedTel: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,
    password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
    qrcode: /^[a-zA-Z0-9]{4}$/,
    url: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
    domain: /([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
    // organizationCode: /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{1}$/, // 组织机构
    organizationCode: /^[a-zA-Z0-9-]+$/, // 组织机构
    businessLicense: /(^[a-zA-Z0-9_-]{15}$)|(^[a-zA-Z0-9_-]{18}$)/,//营业执照
    fixedTele:  /^0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/,
    // fixedTele: /(^(\d{2,4}[-_－—]?)?\d{3,8}([-_－—]?\d{3,8})?([-_－—]?\d{1,7})?$)|(^0?1[35]\d{9}$)/, // 固定电话
    faxTele: /(^(\d{3,4}-)?\d{7,8})$|^((1[0-9][0-9]\d{8}$))/, //传真电话ad
  },
  serverInfo: {
    protocol: window.location.protocol,
    host: window.location.host,
    port: window.location.port,
    path: window.location.pathname,
  },
  EVIDENCE_TYPE: [
    '录屏取证',
    '快照取证',
    '移动端录屏取证',
    '过程取证'
  ],
  PACKAGE_CONFIG: {
    '30001': '快照存证',
    '30002': '录屏存证'
  },
  RIGHTSFILETYPES: {
    doc: {
      rightType:1,
      typeText: '文本',
      ext:[
        "pptx", "ppt", "doc", "docx", "pdf", "xls", "xlsx", "txt", "rtf", "htm", "html", "wpd", "chm", "pdg",
        "wdl", "hlp", "wps", "docm", "dotm", "dot", "xps", "mht", "mhtml", "xml", "odt", "xlsm", "xlsb", "xltx",
        "xltm", "xlt", "csv", "prn", "dif", "slk", "xlam", "ods", "pptm", "potx", "potm", "pot", "thmx", "ppsx",
        "ppsm", "pps", "ppam", "ppa", "odp"
      ],
      maxSize:52428800
    },
    image: {
      rightType:2,
      typeText: '图片',
      ext:[
        "jpg", "png", "bmp", "git", "jpeg", "jpeg2000", "tiff", "psd", "swf", "svg", "pcx", "dxf", "wmf", "emf",
        "lic", "eps", "tga", "exif", "fpx", "cdr", "pcd", "ufo", "ai", "hdri", "raw", "pict"
      ],
      maxSize:52428800
    } ,
    audio: {
      rightType:3,
      typeText: '音频',
      ext:[
        "mp3", "aa", "aac", "a52", "ac3", "aif", "aifc", "aiff", "au", "snd", "cda", "cue", "dts", "wav", "fla",
        "flac", "mid", "midi", "rmi", "far", "it", "mod", "mtm", "s3m", "stm", "umx", "xm", "ape", "mac", "mp1",
        "mp2", "mp3pro", "mpa", "m4a", "mp+", "mpc", "ra", "tak", "tta", "ogg", "wma", "dff", "dsf"
      ],
      maxSize:209715200
    },
    video: {
      rightType:4,
      typeText: '视频',
      ext:[
        "wmv", "mp4", "flv", "rm", "rmvb", "mkv", "avi", "mid", "3gp", "mov", "f4v", "asf", "navi", "webm",
        "mpeg1", "mpeg2", "mpeg4", "divx", "mpg", "mpe", "vob", "ra", "dat", "qt"
      ],
      maxSize:209715200
    }
  },
  INDUSTRY_TYPE: [
    {
      "name": "销售/贸易", "id": 1
    },{
      "name": "电子商务", "id": 2
    },{
      "name": "私营业主", "id": 3
    },{
      "name": "律师", "id": 4
    },{
      "name": "法务", "id": 5
    },{
      "name": "其他法律职业", "id": 6
    },{
      "name": "媒体/记者", "id": 7
    },{
      "name": "教育/培训", "id": 8
    },{
      "name": "广告公关", "id": 9
    },{
      "name": "文化艺术", "id": 10
    },{
      "name": "人力资源", "id": 11
    },{
      "name": "写作/出版", "id": 12
    },{
      "name": "金融财务", "id": 13
    },{
      "name": "保险业", "id": 14
    },{
      "name": "服务业", "id": 15
    },{
      "name": "餐饮/旅游", "id": 16
    },{
      "name": "消费品", "id": 17
    },{
      "name": "娱乐/体育", "id": 18
    },{
      "name": "学术科研", "id": 19
    },{
      "name": "IT/通讯/信息技术", "id": 20
    },{
      "name": "房地产/建筑/装潢", "id": 21
    },{
      "name": "工程/机械/能源", "id": 22
    },{
      "name": "医疗保健", "id": 23
    },{
      "name": "运输物流", "id": 24
    },{
      "name": "制造加工业", "id": 25
    },{
      "name": "农林牧渔业", "id": 26
    },{
      "name": "政府及公共事业机构", "id": 27
    },{
      "name": "非盈利机构/协会团体", "id": 28
    },{
      "name": "在校学生", "id": 29
    },{
      "name": "其他", "id": 30
    }
  ],
  INDUSTRY_TYPE_JSON: {
    '1': "销售/贸易",
    '2': "电子商务",
    '3':"私营业主",
    '4':"律师",
    '5':"法务",
    '6':"其他法律职业",
    '7':"媒体/记者",
    '8':"教育/培训",
    '9':"广告公关",
    '10':"文化艺术",
    '11':"人力资源",
    '12':"写作/出版",
    '13':"金融财务",
    '14':"保险业",
    '15':"服务业",
    '16':"餐饮/旅游",
    '17':"消费品",
    '18':"娱乐/体育",
    '19':"学术科研",
    '20':"IT/通讯/信息技术",
    '21':"房地产/建筑/装潢",
    '22':"工程/机械/能源",
    '23':"医疗保健",
    '24':"运输物流",
    '25':"制造加工业",
    '26':"农林牧渔业",
    '27':"政府及公共事业机构",
    '28':"非盈利机构/协会团体",
    '29':"在校学生",
    '30':"其他"
  },
  INSTITUTION_TYPE: [{
    "name": "一般企业",
    "id": 1
  },{
    "name": "律师事务所",
    "id": 2
  },{
    "name": "行政机关",
    "id": 3
  },{
    "name": "事业单位",
    "id": 4
  },{
    "name": "其他非营利性组织",
    "id": 5
  }]
}


var RIGHTSFILETYPES = {
  doc: [
    "pptx", "ppt", "doc", "docx", "pdf", "xls", "xlsx", "txt", "rtf", "htm", "html", "wpd", "chm", "pdg",
    "wdl", "hlp", "wps", "docm", "dotm", "dot", "xps", "mht", "mhtml", "xml", "odt", "xlsm", "xlsb", "xltx",
    "xltm", "xlt", "csv", "prn", "dif", "slk", "xlam", "ods", "pptm", "potx", "potm", "pot", "thmx", "ppsx",
    "ppsm", "pps", "ppam", "ppa", "odp"
  ],
  // doc: [
  //     "pptx", "ppt", "doc", "docx",  "xls", "xlsx", "pdf"
  // ],
  image: [
    "jpg", "png", "bmp", "git", "jpeg", "jpeg2000", "tiff", "psd", "swf", "svg", "pcx", "dxf", "wmf", "emf",
    "lic", "eps", "tga", "exif", "fpx", "cdr", "pcd", "ufo", "ai", "hdri", "raw", "pict"
  ],
  audio: [
    "mp3", "aa", "aac", "a52", "ac3", "aif", "aifc", "aiff", "au", "snd", "cda", "cue", "dts", "wav", "fla",
    "flac", "mid", "midi", "rmi", "far", "it", "mod", "mtm", "s3m", "stm", "umx", "xm", "ape", "mac", "mp1",
    "mp2", "mp3pro", "mpa", "m4a", "mp+", "mpc", "ra", "tak", "tta", "ogg", "wma", "dff", "dsf"
  ],
  video: [
    "wmv", "mp4", "flv", "rm", "rmvb", "mkv", "avi", "flv", "mid", "3gp", "mov", "f4v", "asf", "navi", "webm",
    "mpeg1", "mpeg2", "mpeg4", "divx", "mpg", "mpe", "vob", "ra", "dat", "qt"
  ]

};
